<ng-container class="parent" *ngIf="formInfo$ | async as fi">
  <ng-container *ngIf="fi.schema; else placeholder">
    <fin-form
      [schema]="fi.schema"
      [options]="fi.options"
      [data]="fi.data"
      [layout]="fi.layout"
      [layoutTemplates]="fi.layoutTemplates"
      (dataChange)="onDataChange($event)"
      (statusChanges)="onStatusChange($event)"
      [components]="addedComponents"
      class="inner-fields"
    >
    </fin-form>
  </ng-container>

  <ng-template #placeholder>
    <div class="placeholder-section" role="region" aria-label="Section placeholder">
      <div class="placeholder-card">
        <h2 class="placeholder-card__title">{{ sectionData?.text || 'Section' }}</h2>
        <p class="placeholder-card__description">
          This section is under development. Form fields will appear here once the schema is configured.
        </p>
      </div>
    </div>
  </ng-template>
</ng-container>
